import {
  DEFAULT_SENDER_EMAIL,
  isValidSenderEmailFormat
} from 'modules/Campaign/functions/sender-email.function'

const YOURVIEWS_DOMAIN = 'yourviews.com.br'

// Mesma regra do backend (ApiSenderEmailSettingsService.DomainPattern)
const DOMAIN_PATTERN =
  /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/

// Mensagens devolvidas pelo backend (EnglishMessages.cs) para a tela Master
const API_STORE_SENDER_ERRORS = {
  'Required field': 'storemanagement.sender.errors.required',
  'Invalid email or empty': 'storemanagement.sender.errors.invalidEmail',
  'Invalid domain': 'storemanagement.sender.errors.invalidDomain',
  'In the yourviews.com.br domain only contato@yourviews.com.br is allowed':
    'storemanagement.sender.errors.yourviewsNotAllowed'
}

export const normalizeDomain = (value) => (value ?? '').trim().toLowerCase()

export const getEmailHost = (email) => {
  const normalized = normalizeDomain(email)
  const at = normalized.lastIndexOf('@')

  return at < 0 ? '' : normalized.substring(at + 1)
}

/**
 * Returns the i18n key of the domain error, or null when it can be added.
 */
export const validateDomain = (domain, domains) => {
  const normalized = normalizeDomain(domain)

  if (!DOMAIN_PATTERN.test(normalized))
    return 'storemanagement.sender.errors.invalidDomain'

  if (normalized === YOURVIEWS_DOMAIN)
    return 'storemanagement.sender.errors.yourviewsNotAllowed'

  if ((domains ?? []).includes(normalized))
    return 'storemanagement.sender.errors.duplicatedDomain'

  return null
}

/**
 * Returns the i18n keys of the default sender errors by field.
 */
export const validateDefaultSender = (email, name) => {
  const errors = {}
  const trimmedEmail = (email ?? '').trim()

  if (!trimmedEmail) return errors

  if (!isValidSenderEmailFormat(trimmedEmail))
    errors.DefaultSenderEmail = 'storemanagement.sender.errors.invalidEmail'
  else if (
    getEmailHost(trimmedEmail) === YOURVIEWS_DOMAIN &&
    normalizeDomain(trimmedEmail) !== DEFAULT_SENDER_EMAIL
  )
    errors.DefaultSenderEmail =
      'storemanagement.sender.errors.yourviewsNotAllowed'

  if (!(name ?? '').trim())
    errors.DefaultSenderName = 'storemanagement.sender.errors.required'

  return errors
}

/**
 * Removed domains that active campaigns still use, with their campaigns.
 * The default sender host stays allowed, so it never counts as removed.
 */
export const getRemovedDomainsInUse = (
  savedDomains,
  domains,
  defaultSenderEmail,
  domainUsages
) => {
  const kept = new Set([...(domains ?? []), getEmailHost(defaultSenderEmail)])

  return (savedDomains ?? [])
    .filter((domain) => !kept.has(domain))
    .map((domain) => ({
      domain,
      campaigns:
        (domainUsages ?? []).find((usage) => usage.Domain === domain)
          ?.Campaigns ?? []
    }))
    .filter((usage) => usage.campaigns.length > 0)
}

/**
 * Maps the API ErrorList to i18n keys by field (DefaultSenderEmail,
 * DefaultSenderName, AllowedDomains[i]).
 */
export const mapStoreSenderApiErrors = (errorList) =>
  (errorList ?? []).reduce((errors, { Field, Error }) => {
    errors[Field] =
      API_STORE_SENDER_ERRORS[Error] ?? 'storemanagement.sender.errors.generic'
    return errors
  }, {})
